import store from '@/store';
import { LanguageType } from './translateTypes';
import { setUserLanguage as setRemoteUserLanguage } from '@/serviceClients/userWebServices'
import Vue from 'vue';
import VueI18n from 'vue-i18n';

const USER_LANGUAGE_KEY = "X-Assistant-Online-User-Language-XXX";

const getSessionLanguage = (): LanguageType | undefined =>
    Vue.$cookies.isKey(USER_LANGUAGE_KEY)
        ? Vue.$cookies.get(USER_LANGUAGE_KEY) as LanguageType
        : undefined;

const setSessionLanguage = (language: LanguageType) => Vue.$cookies.set(USER_LANGUAGE_KEY, language);

const getBrowserLanguage = (): LanguageType | undefined => {
    const browserLanguage = window.navigator.language.toLocaleLowerCase();
    if (browserLanguage.includes("en")) {
        return "en";
    }

    if (browserLanguage.includes("pl")) {
        return "pl";
    }

    if (browserLanguage.includes("ja")) {
        return "ja";
    }

    if (browserLanguage.includes("ru")) {
        return "ru";
    }

    if (browserLanguage.includes("uk")) {
        return "uk";
    }

    if (browserLanguage.includes("ro")) {
        return "ro";
    }

    return undefined;
}

export const setUserLanguage = async (language: LanguageType) => {
    const user = store.getters.module.user;
    if (!!user && user.language !== language) {
        await setRemoteUserLanguage(user.id, language);
    }
    if (getSessionLanguage() !== language) {
        setSessionLanguage(language);
    }
}

export const getLanguage = (): LanguageType => {
    return getSessionLanguage()
        ?? getBrowserLanguage()
        ?? "en";
}

import languages from './translations/languageCodesTranslations/languages.json';
export const getLanguageName = (code: string): string => {
    return languages.filter(l => l.code === code)[0][getLanguage()]
}

let instance: VueI18n;

const geti18n = () => {
    const language = getLanguage();
    const plFile = require('./translations/pl.json');
    const jaFile = require('./translations/ja.json');
    const ruFile = require('./translations/ru.json');
    const ukFile = require('./translations/uk.json');
    instance = new VueI18n({
        locale: language,
        silentTranslationWarn: true,
        formatFallbackMessages: true,
        messages: {
            pl: plFile,
            ja: jaFile,
            ru: ruFile,
            uk: ukFile,
        },
    })

    return instance;
}

export default geti18n;
